import {VerbrauchsanalyseForm} from "../../verbrauchsanalyse/verbrauchsanalyse.form";

/**
 * Configuratuion for the input of the first chapter in the moderat advisor.
 * @inheritDoc
 */
export class VerbrauchsanalyseModeratForm extends VerbrauchsanalyseForm {
  /**
   * @inheritDoc
   */
  modus: string = 'hec';

  /**
   * @inheritDoc
   * @protected
   */
  protected groups: any = {
    'basisinformationen/1': ['nutzungstyp'],
    'basisinformationen/2': ['gebaeudetyp'],
    'basisinformationen/3': ['gebaeude_denkmalschutz'],
    'basisinformationen/4': ['heizungstyp'],
    'basisinformationen/5': ['energietraeger_name'],
    'basisinformationen/6': ['gebaeudebaujahr'],
    'basisinformationen/7': ['postleitzahl', 'ort'],
    'basisinformationen/8': ['bewohneranzahl'],

    'heizsystem/1': ['gebaeude_flaeche'],
    'heizsystem/2': ['anzahl_wohneinheiten'],
    'heizsystem/3': ['keller_status'],
    'heizsystem/4': ['warmwasser_bereitungsart'],
    'heizsystem/5': ['warmwasser_messung'],
    'heizsystem/6': ['zusatzheizung_vorhanden'],
    'heizsystem/7': ['zusatzheizung_energietraeger'],
    'heizsystem/8': ['solarthermie_art'],

    'verbrauchsdaten': ['abrechnungszeitraum', 'energietraeger_verbrauch', 'energietraeger_kosten', 'warmwasser_verbrauch', 'warmwasser_temperatur', 'warmwasser_verbrauch_bekannt', 'zusatzheizung_verbrauch', 'zusatzheizung_verbrauch_bekannt'],

    // wpcheck
    'wpcbasisinformationen/1': ['bewohneranzahl'],
    'wpcbasisinformationen/2': ['anzahl_wohneinheiten'],
    'wpcheizsystem/1': ['warmwasser_messung'],
    'wpcheizsystem/2': ['zusatzheizung_vorhanden'],
    'wpcheizsystem/3': ['zusatzheizung_energietraeger'],
    'wpcheizsystem/4': ['solarthermie_art']
  };

}
